import { render, staticRenderFns } from "./NoAccreditations.vue?vue&type=template&id=de8de030&"
import script from "./NoAccreditations.ts?vue&type=script&lang=ts&"
export * from "./NoAccreditations.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports